export default __webpack_public_path__ + "static/media/pym_reduced.e54c9501.svg";